import React from "react";
import { FiEye, FiTrash2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import IconButton from "../../../components/button/IconButton";
import { SkeletonBar, ActionButtonsSkeleton } from "../../../components/skeleton/Skeleton";

export default function UserRow({ user, onView, onDelete, isLoading = false }) {
  const { t } = useTranslation();
  return (
    <li
      className="
        bg-white rounded-xl border border-gray-200 px-4 sm:px-6 py-3
        flex items-center justify-between gap-4
        md:grid md:grid-cols-[1fr_1fr_1fr_auto] md:items-center md:gap-x-10
      "
    >
      <div className="min-w-0 flex-1 md:contents">
        <div className="min-w-0">
          {isLoading ? (
            <div className="h-4 bg-lightGray rounded-lg w-48 animate-pulse" />
          ) : (
            <div className="font-medium text-darkGray text-sm sm:text-base truncate">
              {user?.email}
            </div>
          )}
        </div>

        <div className="mt-2 space-y-1 text-sm text-darkGray md:mt-0 md:space-y-0 md:contents">
          <div className="md:text-center md:flex md:justify-center">
            {isLoading ? (
              <SkeletonBar width="w-24" />
            ) : (
              user?.createdAt
            )}
          </div>
          <div className="md:text-center md:flex md:justify-center">
            {isLoading ? (
              <SkeletonBar width="w-20" />
            ) : (
              <span className="capitalize">{user?.role}</span>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col items-end gap-2 md:flex-row md:items-center md:justify-self-end md:gap-3">
        {isLoading ? (
          <>
            <ActionButtonsSkeleton />
          </>
        ) : (
          <>
            <IconButton
              aria-label={t("ACTIONS.VIEW")}
              onClick={() => onView?.(user)}
            >
              <FiEye className="text-lg text-gray-700" />
            </IconButton>

            <IconButton
              aria-label={t("ACTIONS.DELETE")}
              onClick={() => onDelete?.(user)}
            >
              <FiTrash2 className="text-lg text-red" />
            </IconButton>
          </>
        )}
      </div>
    </li>
  );
}